import { Controller } from "@hotwired/stimulus"

// Removes its element when the dismiss action fires — the close button on a
// banner the user can acknowledge and hide (e.g. the publish-warnings alert).
// The element is rendered visible so it still shows without JS; only the
// close affordance depends on this controller.
export default class extends Controller {
  dismiss() {
    this.element.remove()
  }
}
